import { render, staticRenderFns } from "./DialogSessionGamification.vue?vue&type=template&id=36b526fe&scoped=true"
import script from "./DialogSessionGamification.js?vue&type=script&lang=js&external"
export * from "./DialogSessionGamification.js?vue&type=script&lang=js&external"
import style0 from "./DialogSessionGamification.vue?vue&type=style&index=0&id=36b526fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b526fe",
  null
  
)

export default component.exports